/*
 * Author: Alexandre Ferri
 * Created on Wed Jun 12 2019
 *
 * Copyright (c) 2019 Zapala Corp
 */
import axios from "axios";

import { USER_TOKEN } from "../constants";
import deleteAllTokens from "../util/deleteAllTokens";
import env from "../util/env";

const httpBlob = axios.create({
  baseURL: env.API_URL,
  timeout: 0,
});

const post = (url, data, config) => {
  return new Promise((resolve, reject) => {
    httpBlob
      .post(url, data, config)
      .then((result) => {
        resolve(result);
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          const shouldSignOut = !err.response?.data?.message?.toLowerCase().includes("session");

          if (shouldSignOut) {
            deleteAllTokens();
            window.location.replace("/signin");
          }
        }
        reject(err);
      });
  });
};

const put = (url, data, config) => {
  return new Promise((resolve, reject) => {
    httpBlob
      .put(url, data, config)
      .then((result) => {
        resolve(result);
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          const shouldSignOut = !err.response?.data?.message?.toLowerCase().includes("session");

          if (shouldSignOut) {
            deleteAllTokens();
            window.location.replace("/signin");
          }
        }
        reject(err);
      });
  });
};

const get = (url, config) => {
  return new Promise((resolve, reject) => {
    httpBlob
      .get(url, config)
      .then((result) => {
        resolve(result);
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          const shouldSignOut = !err.response?.data?.message?.toLowerCase().includes("session");

          if (shouldSignOut) {
            deleteAllTokens();
            window.location.replace("/signin");
          }
        }
        reject(err);
      });
  });
};

const deleteApi = (url, config) => {
  return new Promise((resolve, reject) => {
    httpBlob
      .delete(url, config)
      .then((result) => {
        resolve(result);
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          const shouldSignOut = !err.response?.data?.message?.toLowerCase().includes("session");

          if (shouldSignOut) {
            deleteAllTokens();
            window.location.replace("/signin");
          }
        }
        reject(err);
      });
  });
};

httpBlob.interceptors.request.use((config) => {
  const token = localStorage.getItem(USER_TOKEN);

  config.headers.Authorization = token || "";

  return config;
});

export default { post, put, get, deleteApi };
